import { render, staticRenderFns } from "./InvoicesBrowse.vue?vue&type=template&id=99901eba&scoped=true"
import script from "./InvoicesBrowse.vue?vue&type=script&lang=js"
export * from "./InvoicesBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99901eba",
  null
  
)

export default component.exports